import some from 'lodash/some';

export function searchFormHasValues(searchForm) {
    return some(searchForm, value => value !== '');
}
